import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const MiscOnOffGlyph = /*#__PURE__*/createElement("g", {
  id: "misc_on_off"
}, /*#__PURE__*/createElement("path", {
  d: "M36.08 28.12h-9.13c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h9.13c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M26.95 58.88c-.83 0-1.5-.67-1.5-1.5V26.62c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v30.76c0 .83-.68 1.5-1.5 1.5zm18.26 0h-9.13c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h9.13c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M36.08 58.88c-.83 0-1.5-.67-1.5-1.5V26.62c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v30.76c0 .83-.67 1.5-1.5 1.5zm-9.13 0h-6.13c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h6.13c.83 0 1.5.67 1.5 1.5s-.68 1.5-1.5 1.5zm27.44-30.76h-9.13c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h9.13c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M45.26 58.88c-.83 0-1.5-.67-1.5-1.5V26.62c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v30.76c0 .83-.67 1.5-1.5 1.5zM60.53 58.88H54.4c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h6.13c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M54.39 58.88c-.83 0-1.5-.67-1.5-1.5V26.62c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v30.76c0 .83-.67 1.5-1.5 1.5zM45.26 58.88h-9.13c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h9.13c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
}), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
  d: "M67.52 43.5h-51.4c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h51.4c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M63.28 48.52c-.38 0-.77-.15-1.06-.44a1.49 1.49 0 010-2.12L66.18 42l-3.96-3.96a1.49 1.49 0 010-2.12 1.49 1.49 0 012.12 0l4.31 4.31c.97.97.97 2.56 0 3.54l-4.31 4.31c-.29.29-.67.44-1.06.44zm3.25-6.17z"
})));
const MiscOnOff = createSvg({
  name: 'misc_on_off',
  path: MiscOnOffGlyph
});

export default MiscOnOff;
export { MiscOnOffGlyph };
